module.exports = __webpack_public_path__ + "11b70d8d108e703662f22df41265dc50.pdf";